import { gozokiApiWithAuth } from '../gozokiApi'

interface VisioLink {
  url: string
  message: string
  token: string
}

export const fetchAskVisio = async (
  kioskId: number,
  includeVideo: boolean,
  openingEventId?: number,
  signal?: AbortSignal,
) => {
  const res = await gozokiApiWithAuth.post<VisioLink>(
    `/visio/start/${kioskId}`,
    {
      includeVideo,
      openingEventId,
    },
    { signal },
  )
  return res.data
}
